<template >
  <div class="container-flight margin_container_hf">
    <PDKModal
      :buttonObject="modalButtonProps"
      v-if="showTimerModal"
      @btnAction="goToSearch"
    >
      <div style="text-align: center" slot="body">
        <img
          id="timer-logo"
          width="150"
          height="150"
          src="../../../public/img/out-of-ti.png"
        />
        <h4 style="margin-top: 10px">
{{ $t("SearchResults.ConfirmTimeExpired") }}
        </h4>
      </div>
    </PDKModal>

    <HotelSearch :hotelList="hotelList" :cityList="cityList" />
    <h1></h1>
    <!-- <hotel-search :hotelList.async="hotelList" :cityList.async="cityList" /> -->
    <div>
      <h3><i class="icon-info-1"></i>{{ $t("SearchResults.HotelInformation") }}</h3>
    </div>
    <div class="container custom_container">
      <div class="custom_row row">
        <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
          <div class="row">
            <div class="b-left col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="hotel">
                <div style="display: inline-flex">
                  <div style="width: 150px" class="hotel-image">
                    <img
                      v-if="Object.keys(hotelImage).length"
                      id="hotel-image"
                      width="90%"
                      height="140"
                      :src="hotelImage[0].url"
                    />
                    <img v-else id="hotel-image" width="90%" height="140" />

                    <HotelStars style="text-align: center" />
                    <div class="u-centerboth" style="text-align: center">
                      <!-- <div data-v-1bbc1f64="" class="u-stars">
                          <i
                            data-v-1bbc1f64=""
                            aria-hidden="true"
                            class="fa fa-star u-star"
                          ></i
                          ><i
                            data-v-1bbc1f64=""
                            aria-hidden="true"
                            class="fa fa-star u-star"
                          ></i
                          ><i
                            data-v-1bbc1f64=""
                            aria-hidden="true"
                            class="fa fa-star u-star"
                          ></i
                          ><i
                            data-v-1bbc1f64=""
                            aria-hidden="true"
                            class="fa fa-star u-star"
                          ></i
                          ><i
                            data-v-1bbc1f64=""
                            aria-hidden="true"
                            class="fa fa-star u-star"
                          ></i>
                        </div> -->
                    </div>
                  </div>

                  <div id="hotel-detail">
                    <span id="hotel-title" class="row">{{
                      selectedHotel[0].hotelName
                    }}</span>
                    <span
                      v-for="(room, index) in filteredRooms"
                      :key="index"
                      style="font-size: 14px; display: flex"
                      ><i class="icon-ok-3"></i>
                      <div>{{ room.name }} × {{ room.count }}</div>
                    </span>
                    <span style="font-size: 14px; display: flex"
                      ><i class="icon-ok-3"></i>
                      <div> {{ $t("SearchResults.Refundable") }}</div>
                    </span>
                    <span style="font-size: 14px; display: flex"
                      ><i class="icon-ok-3"></i>
                      <div>{{ $t("SearchResults.InhabitancyWithBreakfast") }}</div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
          <div class="total-pay">
            <div class="row">
              <div style="text-align: center" id="title" class="col">
                <i class="icon-warehouse filter-icon"></i>
                <span style="text-align: center" id="title">{{ $t("Hotel") }}</span>
              </div>
            </div>

            <div class="row">
              <span style="font-size: 16px"
                >{{ $t("SearchResults.ForEachNightStay") }}
                <label class="stay-price" id="price">{{
                  roomTotalPrice | numFormat | rial
                }}</label></span
              >
            </div>
            <div class="total-price row">
              <span
                >{{ $t("SearchResults.TotalPriceInhabitancy") }} :
                <label style="font-weight: bold; color: rgb(4, 112, 167)">{{
                  packageTotalPrice | numFormat | rial
                }}</label></span
              >
            </div>
            <div style="justify-content: center" class="total-price row">
              <button
                type="button"
                class="btn btn-info"
                data-toggle="modal"
                data-target=".bd-example-modal-lg"
              >
                {{ $t("Details") }} 
              </button>
              <!-- Modal -->
              <div
                class="modal fade bd-example-modal-lg"
                id="exampleModalCenter"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal-dialog-centered modal-xl"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <!-- <span aria-hidden="true">&times;</span> -->
                      </button>
                    </div>
                    <div class="modal-body">
                      <InvoiceDetailsHotel />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row custom_rows">
      <!-- <aside class="col-md-3">
    </aside> -->
      <div class="col-md-12">
        <div class="col-md-12">
          <div style="display: flex" class="form_title">
            <div>
              <h3 style="display: flex">
                <strong>
                  <i class="icon-user-1" />
                </strong>
                {{ $t("SearchResults.PassengersInfo") }} 

                <div style="position: absolute; left: 0">
                  <vue-countdown-timer
                    style="
                      direction: ltr;
                      font-size: 23px;
                      color: rgb(147 168 189);
                      margin-right: 10px;
                      background: #ffffff;
                      margin-top: 5px;
                      outline: 4px dashed #c9cfd5;
                      outline-offset: -3px;
                      width: 115px;
                      text-align: center;
                      padding: 9px 13px;
                      border-radius: 9px;
                    "
                    @end_callback="endTimeCountdown()"
                    :start-time="startAt"
                    :end-time="endAt"
                    :interval="1000"
                    label-position="begin"
                    :day-txt="null"
                    :hour-txt="null"
                    :seconds-txt="null"
                    :show-zero="true"
                    :end-text='$t("SearchResults.YourTimeIsUp")'
                  >
                  </vue-countdown-timer>
                </div>
              </h3>

              <p>{{ $t("SearchResults.EnterFullDetailsOfPassengers") }} </p>
            </div>
          </div>
          <div style="padding: 10px 7% 10px 7% !important" class="step">
            <div v-for="(item, index) in passengers" :key="index">
              <div class="custom_form_title form_title">
                <h3 style="font-size: 16px">
                  <strong>
                    <i :class="item.icon"></i>
                  </strong>
                  <div>
                    <span> {{ item.title }} </span>
                    <label style="color: #0a6c9f" v-if="index === 0"
                      >({{ $t("SearchResults.MainGuest") }} )</label
                    >
                  </div>
                </h3>
                <p>{{ item.subTitle }}</p>
              </div>

              <div class="step">
                <PassengerForm
                  :ageType="item.type"
                  :duplicatedNationalCode="duplicatedNationalCode"
                  :isMainGuest="index === 0"
                  :formId="index"
                  :entriedForm="onEntriedForm(index)"
                  :checkValid="checkValid"
                  ref="passengerForm"
                  @isValid="onValidationForm($event, index)"
                  @values="onFormValue($event, index)"
                />
              </div>
            </div>

            <div v-if="isTransfer" class="row">
              <h3 style="font-size: 20px">
                {{ $t("SearchResults.LikeToUseTransferService") }}
              </h3>
              <label
                style="margin: 17px 10px 0px 10px"
                class="switch-light switch-ios float-right"
              >
                <input
                  type="checkbox"
                  name="option_1"
                  id="option_1"
                  :checked="false"
                  v-model="showTransferForm"
                />
                <span>
                  <span>{{ $t("No") }}</span>
                  <span>{{ $t("Yes") }}</span>
                </span>
                <a></a>
              </label>
            </div>
          </div>
        </div>

        <div v-if="showTransferForm" class="col-md-12">
          <div class="form_title">
            <h3>
              <strong>
                <i class="icon-bus" />
              </strong>
              <div style="display: flex">
                <span> {{ $t("SearchResults.TransferInformation") }} </span>
                <div></div>
              </div>
            </h3>
            <p>{{ $t("SearchResults.EnterAirportTransferInformation") }} </p>
          </div>
          <div class="step">
            <HotelTransferInfo
              :entriedForm="entriedTransferForm"
              :checkValid="checkValidTransfer"
              ref="transferInfoForm"
              @isValid="onValidationTransferForm"
              @values="onTransferFormValue($event)"
            />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form_title">
            <h3>
              <strong>
                <i class="icon-edit-2" />
              </strong>
              {{ $t("SearchResults.GuestRequest") }}
            </h3>
            <p>{{ $t("SearchResults.EnterYourRequestInBox") }}</p>
          </div>
          <div class="step">
            <div class="row">
              <div class="col-md-12">
                <div class="group_mdi">
                  <!-- <label>درخواست میهمان</label> -->
                  <input v-model="guestRequest" />
                  <span class="highlight"></span>
                  <span class="bar"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <button @click="goNext()" class="btn-sub col-md-4 btn btn-primary">
            {{ $t("SearchResults.NextStep") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PassengerForm from "../../components/hotel/HotelPassengers";
import HotelTransferInfo from "../../components/hotel/HotelTransferInfo";
import store from "../../views/hotel/store/index";
import HotelStars from "../../components/tour/HotelStars";
import HotelSearch from "../../components/hotel/HotelSearch";
import dateUtil from "../../utils/date";
import moment from "moment";
import PDKModal from "@/components/PDKAlertModal";
import InvoiceDetailsHotel from "../../components/hotel/InvoiceDetailsHotel.vue";

var qs = require("qs");

export default {
  name: "HotelBook",
  components: {
    HotelTransferInfo,
    PDKModal,
    HotelStars,
    PassengerForm,
    HotelSearch,
    InvoiceDetailsHotel,
  },
  store,
  data() {
    return {
      hotelImage: [],
      duplicatedNationalCode: false,
      showTransferForm: false,
      selectedRoom: [],
      passengers: [],
      passengerForm: [],
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      showTimerModal: false,
      skletonModel: {
        isDeparture: false,
        isReturn: false,
        isToway: false,
        isRoom: false,
        isTotalPrice: false,
      },
      searchItems: {},
      params: {},
      forms: new Array(),
      selectedHotel: {},
      adultCount: 0,
      childCount: 0,
      infantCount: 0,
      endAt: new Date().getTime() + 600000,
      startAt: new Date().getTime(),
      bookingDetails: {},
      guestRequest: "",
      checkValid: false,
      checkValidTransfer: false,
      isValidForm: false,
      isValidTransferForm: false,
      transferInfoForm: {},
      hotelList: [],
      cityList: [],
      roomsList: [],
      showCombineRoom: false,
      totalNight: 0,
      entriedForm: {},
      entriedTransferForm: {},
      isTransfer: false,
      validForms: [],
    };
  },
  watch: {
    showTransferForm(val) {
      if (val === true) {
        this.isValidTransferForm = false;
      }
    },
    isValidTransferForm: function (val) {
      if (val === false) {
        this.checkValidTransfer = false;
      } else if (val === null) {
        this.checkValidTransfer = true;
      } else if (val === true) {
        this.checkValidTransfer = false;
        this.checkValid = true;
      }
    },
    isValidForm: function (val) {
      this.checkIsValidForm(val);
    },
    checkValid: function (val) {
      return (this.checkValid = val);
    },

    duplicatedNationalCode: function (val) {
      return (this.duplicatedNationalCode = val);
    },

    checkValidTransfer: function (val) {
      return (this.checkValidTransfer = val);
    },
  },
  created() {
    this.params = this.$route.query;
    this.selectedHotel = this.$store.getters["hotel/GetSelectedHotelRoom"];
    const hotelInfo = this.$store.getters["hotel/GetHotelDetails"];

    if (!Object.keys(hotelInfo).length) {
      this.goToSearch();
    }
    var hotelImageUrl = hotelInfo.imageURL;
    hotelInfo.hotelImages.forEach((img) => {
      this.hotelImage.push({
        url: hotelImageUrl + img.hotelImageID,
        caption: img.caption,
      });
    });

    this.isTransfer = hotelInfo.hotelDetail.transfer;

    window.scrollTo(0, 0);

    this.duplicatedNationalCode = true;
    this.getLocationList();
    this.getHotelList();
    this.createRequest();

    this.getPaxs();
    this.calculateTotalNight();
    var bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];
    if (!Object.keys(bookingDetail).length) {
      for (var i = 0; i < this.passengers.length; i++) {
        this.passengerForm.push({
          formValues: {
            persianName: "",
            persianFamily: "",
            englishName: "",
            englishFamily: "",
            genderId: "",
            nationalityId: "",
            nationalCode: "",
            birthDate: "",
          },
        });
      }
    }
    this.showTransferForm = bookingDetail.hasTransferModel;
    for (let i = 0; i < this.passengers.length; i++) {
      this.validForms[i] = false;
    }

    this.onEntriedTransferForm();
  },
  methods: {
    checkIsValidForm(val) {
      var isValidForms = true;

      this.validForms.forEach((el) => {
        if (el === false) {
          isValidForms = false;
        }
      });

      if (isValidForms === true) {
        var bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];
        var passengers = [];

        if (this.passengerForm.length > 0) {
          this.passengerForm.forEach((element) => {
            passengers.push(element.formValues);
          });
        } else if (Object.keys(bookingDetail).length) {
          this.guestRequest = bookingDetail.guestRequest;

          passengers = bookingDetail.passengers;

          bookingDetail.passengers.forEach((element) => {
            var obj = {};
            obj.formValues = element;

            this.passengerForm.push(obj);
          });
        }

        var transferModel = {};

        if (
          !Object.keys(this.transferInfoForm).length &&
          bookingDetail.transferModel !== undefined
        ) {
          transferModel = bookingDetail.transferModel;
        } else {
          transferModel = this.transferInfoForm;
        }
        var ss = this.selectedHotel;
        this.bookingDetails = {
          hotel: this.selectedHotel,
          passengers: passengers,
          guestRequest: this.guestRequest,
          fromDate: this.params.startDate,
          toDate: this.params.endDate,
          numberOfAdult: this.adultCount,
          numberOfChild: this.childCount,
          numberOfInfant: this.infantCount,
          hotelId: this.params.hotelId,
          transferModel: transferModel,
          hasTransferModel: this.showTransferForm,
          sourceId: localStorage.getItem("SourceIdInReport"),
        };

        this.$store.dispatch("hotel/HotelBookingDetails", this.bookingDetails);
        const request = {
          hotelId: this.params.hotelId,
          startDate: this.params.startDate,
          endDate: this.params.endDate,
          city: this.params.city,
          rooms: this.params.rooms,
        };

        var valuesAlreadySeen = [];
        var isBreak = false;
        var isDuplicate = false;
        for (var i = 0; i < this.passengerForm.length; i++) {
          var value = this.passengerForm[i];

          for (var j = 0; j < valuesAlreadySeen.length; j++) {
            if (valuesAlreadySeen[j].formValues.nationalCode !== "") {
              if (
                valuesAlreadySeen[j].formValues.nationalCode ===
                value.formValues.nationalCode
              ) {
                this.duplicatedNationalCode = false;
                isBreak = true;
                isDuplicate = true;
                break;
              } else {
                this.duplicatedNationalCode = true;
              }
            }
          }

          if (!isBreak) {
            valuesAlreadySeen.push(value);
          } else {
            valuesAlreadySeen = [];
            break;
          }
        }

        if (!isDuplicate) {
          this.$router
            .push({
              name: "hotelconfirm",
              query: request,
            })
            .catch(() => {});
        }
      } else {
        return;
      }
    },
    checkForDuplicatedNationalCode(array) {
      var valuesAlreadySeen = [];

      for (var i = 0; i < array.length; i++) {
        var value = array[i];

        valuesAlreadySeen.forEach((element) => {
          if (element.formValues.nationalCode !== "") {
            if (
              element.formValues.nationalCode === value.formValues.nationalCode
            ) {
              this.duplicatedNationalCode = true;

              return true;
            }
          }
        });
        // if (valuesAlreadySeen.indexOf(value.formValues.nationalCode) !== -1) {
        //   return true
        // }
        valuesAlreadySeen.push(value);
      }
      this.duplicatedNationalCode = false;

      return false;
    },

    onEntriedTransferForm() {
      this.isValidForm === false;
      //  this.isValidTransferForm = false;
      var bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];
      if (Object.keys(bookingDetail).length) {
        this.guestRequest = bookingDetail.guestRequest;
        if (
          Object.keys(bookingDetail.transferModel).length &&
          bookingDetail.hasTransferModel
        ) {
          this.showTransferForm = true;

          this.entriedTransferForm = bookingDetail.transferModel;
        } else {
          var formValues = {
            transportVehicle: "",
            leaveDate: "",
            returnDate: "",
            leaveTime: "",
            returnTime: "",
            LeaveDescription: "",
            ReturnDescription: "",
          };
          this.entriedTransferForm = formValues;
        }
      } else {
        var formValues = {
          transportVehicle: "",
          leaveDate: "",
          returnDate: "",
          leaveTime: "",
          returnTime: "",
          LeaveDescription: "",
          ReturnDescription: "",
        };
        this.entriedTransferForm = formValues;
      }
    },

    onEntriedForm(indx) {
      this.isValidForm === false;
      // this.isValidTransferForm = false;
      var bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];
      if (Object.keys(bookingDetail).length) {
        // bookingDetail.passengers.forEach((element) => {
        //   var formValues =element;
        //   this.passengerForm.push(formValues);
        //   });
        return bookingDetail.passengers[indx];
      } else {
        var formValues = {
          mobilePhone: "",
          email: "",
          persianName: "",
          persianFamily: "",
          englishName: "",
          englishFamily: "",
          genderId: "",
          nationalityId: "",
          nationalCode: "",
          birthDate: "",
        };
        return formValues;
      }
    },
    onTransferFormValue(val) {
      this.transferInfoForm = val;
    },
    endTimeCountdown() {
      this.showTimerModal = true;
    },
    goToSearch() {
      const request = {
        hotelId: this.params.hotelId,
        startDate: this.params.startDate,
        endDate: this.params.endDate,
        city: this.params.city,
        rooms: this.params.rooms,
      };

      this.$router
        .push({
          name: "hotelrooms",
          query: request,
        })
        .catch(() => {});
    },
    roomCount(array) {
      let counts = array.reduce(
        (out, { name }) => ({ ...out, [name]: out[name] + 1 || 1 }),
        {}
      );
      return Object.keys(counts).map((key) => ({
        name: key,
        count: counts[key],
      }));
    },
    onFormValue(val, x) {
      this.duplicatedNationalCode = true;
      var bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];
      if (
        Object.keys(bookingDetail).length &&
        this.passengerForm.length === 0
      ) {
        this.passengerForm = [];
        bookingDetail.passengers.forEach((element) => {
          var obj = {};
          obj.formValues = element;

          this.passengerForm.push(obj);
        });
      }

      if (this.passengerForm.length === 0) {
        for (var i = 0; i < this.passengers.length; i++) {
          this.passengerForm.push({
            formValues: {
              persianName: "",
              persianFamily: "",
              englishName: "",
              englishFamily: "",
              genderId: "",
              nationalityId: "",
              nationalCode: "",
              birthDate: "",
            },
          });
        }
      }
      this.passengerForm[x].formValues = val;
    },
    onValidationForm(val, index) {
      if (val === null) {
        this.checkValid = true;
      } else {
        this.validForms[index] = val;
        this.isValidForm = val;
        this.checkIsValidForm(true);
      }
    },
    onValidationTransferForm(val) {
      if (val === null) {
        this.checkValidTransfer = true;
      } else {
        this.isValidTransferForm = val;
      }
    },
    createRequest() {
      const params = this.$route.query;

      this.request = {
        startDate: params.startDate,
        endDate: params.endDate,
        hotelId: params.hotelId,
      };

      // this.getRoomsList();
    },

    getRoomsList() {
      this.$store
        .dispatch("getAvailRoomList", qs.stringify(this.request))
        .then((res) => {
          this.roomsList = res;
        });
    },
    async getLocationList() {
      this.cityList = await this.$store.dispatch("getLocations");
      this.cityList = this.cityList.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );
    },
    async getHotelList() {
      const hotelList = await this.$store.dispatch("getHotelList");

      if (Array.isArray(hotelList)) {
        this.mapHotelData(hotelList);
      }
    },
    mapHotelItem(item) {
      const data = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "Hotel",
      };

      return data;
    },
    mapHotelData(hotelList) {
      hotelList.forEach((element) => {
        const data = this.mapHotelItem(element);

        this.hotelList.push(data);
      });
    },
    getPaxs() {
      var rooms = JSON.parse(this.params.rooms);

      var adult = 0;
      var child = 0;
      var infant = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age >= 2) {
            child = child + 1;
          }
        });
      });
      rooms.forEach((element) => {
        adult = adult + Number(element.adults);
      });

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age < 2) {
            infant = infant + 1;
          }
        });
      });

      this.adultCount = adult;
      this.infantCount = infant;
      this.childCount = child;
      for (var i = 0; i < this.adultCount; i++) {
        this.passengers.push({
          type: "ADL",
          title: "بزرگسال",
          subTitle: "بیشتر از 12 سال",
          icon: "icon-adult",
        });
      }
      for (var i = 0; i < this.childCount; i++) {
        this.passengers.push({
          type: "CHL",
          title: "کودک",
          subTitle: "2 تا 12 سال",
          icon: "icon-child",
        });
      }
      for (var i = 0; i < this.infantCount; i++) {
        this.passengers.push({
          type: "INF",
          title: "نوزاد",
          subTitle: "کمتر از 2 سال",
          icon: "icon-guest",
        });
      }
    },
    goNext() {
      if (!this.showTransferForm) {
        this.isValidTransferForm = true;
      }
      if (this.isValidTransferForm === false) {
        this.checkValidTransfer = !this.checkValidTransfer;
        return;
      }

      if (this.isValidForm === false) {
        this.checkValid = !this.checkValid;
        return;
      }

      // else {
      //   this.checkValid = true;
      // }
      if (this.isValidForm === true && this.isValidTransferForm === true) {
        this.checkValid = !this.checkValid;
        this.checkValidTransfer = false;
        // this.checkValid = false;
        this.checkIsValidForm(true);
      }
    },
    calcRoomTotalPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },
    calculateTotalNight() {
      var fromDate = dateUtil.ConvertToPersian(this.params.startDate);
      var toDate = dateUtil.ConvertToPersian(this.params.endDate);
      this.totalNight = 0;
      if (
        fromDate != "" &&
        fromDate != null &&
        toDate != "" &&
        toDate != null
      ) {
        // var diff = moment(this.params.endDate).diff(moment(this.params.startDate), "days");
        let fDate = this.params.startDate;
        let tDate = this.params.endDate;

        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());

        // var diff = moment(tDate).diff(moment(fDate), "days");
        this.totalNight = diff;
      } else {
        this.totalNight = 0;
      }
    },
  },
  computed: {
    filteredRooms() {
      return this.roomCount(this.selectedHotel);
    },
    roomTotalPrice() {
      return this.calcRoomTotalPrice(this.selectedHotel);
    },

    packageTotalPrice() {
      var roomPrice = this.calcRoomTotalPrice(this.selectedHotel);
      var totalRoom = roomPrice * this.totalNight;

      return totalRoom;
    },
  },
  destroyed() {},
};
</script>
<style   scoped >
@media only screen and (max-width: 750px) {
  .btn-sub {
    margin: 25px !important;
  }
}

.btn-sub {
  height: 35px !important;
  margin: auto;
}

.hotel-image {
  margin-left: 10px;
  margin-top: 8px;
}

.stay-price {
  color: black;
  font-size: 16px;
}

.total-price {
  font-size: 16px;
  margin-top: 6px;
}

.title span #price {
  font-weight: bold;
}

.total-pay {
  padding: 10% 40px 10% 0px;
}

.total-pay a {
  margin-top: 22px;
}

.total-pay span {
  margin: auto;
}

.total-pay #title {
  margin: auto;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

#hotel-detail {
  line-height: 24px;
  font-size: 13px;
  padding: 0px 2px 0px 0px;
}

#hotel-title {
  margin-right: 3px;
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 11px;
  margin-top: 14px;
}

.hotel #hotel-image {
  border-radius: 8px;
  margin-left: 5px;
}

#hotel-image {
  margin: 0px 10px 5px 0px;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.margin_60 {
  padding-top: 120px;
  padding-bottom: 60px;
}

.search-box {
  position: relative;
  padding: 40px 0;
}

.custom_form_title h3 strong {
  margin-top: -4px !important;
  margin-right: 3px !important;
  height: 35px !important;
  width: 35px !important;
  background-color: #bdc6cb !important;
}

.custom_form_title {
  margin-bottom: 0px !important;
  padding-right: 45px !important;
}

.custom_row {
  border-top: 2px #00c3e1 solid;

  margin: 3px 0px 3px 0px;
  padding-top: 5px;
}

.styled-select {
  background-color: white !important;
  border: 1px solid #ced4da !important;
}

.custom_container {
  background-color: rgb(255, 255, 255);
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 3px 3px 3px 3px #aaaaaa4a;
}

.flight {
  padding: 0px 0px 0px 0px;
}

.flight #departure {
  margin: 10px 0 10px 0;
}

.flight #departure .icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 15px;
  color: #867b7b;
}

.flight #departure #action-icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 18px;
  color: #8da6b3;
  margin-right: 15px;
}

.action:hover {
  cursor: pointer;
}

.segment {
  text-align: center;
  display: grid;
}

.b-left {
  border-left: 1px #e2e2e2 solid;
}

.subtitle {
  border-top: 1px #c5c5c5 solid;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px 1px 10px 1px;
}

.subtitle-display {
  display: none;
}

.subtitle div {
  text-align: left;
  color: #265215;
  font-size: 15px;
}
</style>
